// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SyncOutlinedSvg from "@fishx/icons-svg/es/asn/SyncOutlined";
import FishxIcon from '../components/FishxIcon';

var SyncOutlined = function SyncOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SyncOutlinedSvg
  }));
};

SyncOutlined.displayName = 'SyncOutlined';
export default React.forwardRef(SyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SyncOutlined.js
// module id = 4217
// module chunks = 0